import { useMutation, useQuery, useSubscription } from "@apollo/react-hooks";
import { Col, Layout, Row } from "antd";
import moment from "moment-timezone";
import React, { useEffect, useState } from "react";
import { SummaryCard } from "../../Components/Cards/Dashboard/SummaryCard";
import { Loader } from "../../Components/Loader";
import { UPDATE_USER_LAST_SCREEN } from "../../Graphql/mutations";
import { GET_LAST_SCREEN } from "../../Graphql/queries";
import {
	GET_DASHBOARD_EMPLOYEE_COUNT,
	GET_DASHBOARD_LOCATION_COUNT,
	GET_DASHBOARD_TODAYS_TASK_COUNT,
	GET_DASHBOARD_WEEKLY_TASK_COUNT,
	GET_OWNER_LOCATION_COUNT,
	USER_TIMEZONE_SUBSCRIPTION,
} from "../../Graphql/subscriptions";
import { Announcement } from "./Announcement/Announcement";
import "./Dashboard.less";
import { EmployeesLeave } from "./EmployeesLeave/EmployeesLeave";
import { Escalations } from "./Escalations/Escalations";
import { TaskForDay } from "./TaskForDay";
import { TopPerformer } from "./TopPerformer/TopPerformer";
const { Content } = Layout;

export const DashboardPage = ({ userData }) => {
	const [totalTasksCompletedToday, setTotalTasksCompletedToday] = useState(0);
	const [totalTasksAssignedToday, setTotalTasksAssignedToday] = useState(0);
	const [totalTasksAssignedLastWeek, setTotalTasksAssignedLastWeek] =
		useState(0);
	const [totalTasksCompletedLastWeek, setTotalTasksCompletedLastWeek] =
		useState(0);
	const [isModalVisible, setIsModalVisible] = useState(false);

	const { data: lastScreenData } = useQuery(GET_LAST_SCREEN, {
		variables: { user_id: localStorage.getItem("user_id") },
		fetchPolicy: "cache-and-network",
	});
	const [UPDATE_USER_LAST_SCREEN_MUTATION] = useMutation(
		UPDATE_USER_LAST_SCREEN
	);

	const { data: locationData, loading: locationLoading } = useSubscription(
		GET_DASHBOARD_LOCATION_COUNT,
		{
			variables: {
				user_id: localStorage.getItem("user_id"),
			},
		}
	);

	const { data: ownerlocationData, loading: ownerlocationLoading } =
		useSubscription(GET_OWNER_LOCATION_COUNT, {
			variables: {
				user_id: localStorage.getItem("user_id"),
			},
		});

	const { data: employeeData, loading: employeeLoading } = useSubscription(
		GET_DASHBOARD_EMPLOYEE_COUNT,
		{
			variables: {
				user_id: localStorage.getItem("user_id"),
			},
		}
	);

	const { data: userTimezoneData, loading: userTimezoneDataLoading } =
		useSubscription(USER_TIMEZONE_SUBSCRIPTION, {
			variables: {
				user_id: localStorage.getItem("user_id"),
			},
		});
	const { data: todaysTaskData, loading: todaysTaskDataLoading } =
		useSubscription(GET_DASHBOARD_TODAYS_TASK_COUNT, {
			variables: {
				user_id: localStorage.getItem("user_id"),
				todays_date: moment
					.tz(moment(), userTimezoneData?.getUsersById.time_zone)
					.format("YYYY-MM-DD"),
			},
			skip: !userTimezoneData,
		});

	const { data: weeklyTaskData, loading: weeklyTaskDataLoading } =
		useSubscription(GET_DASHBOARD_WEEKLY_TASK_COUNT, {
			variables: {
				user_id: localStorage.getItem("user_id"),
				start_date: moment
					.tz(moment(), userTimezoneData?.getUsersById.time_zone)
					.subtract(8, "days")
					.format("YYYY-MM-DD"),
				end_date: moment
					.tz(moment(), userTimezoneData?.getUsersById.time_zone)
					.subtract(1, "days")
					.format("YYYY-MM-DD"),
			},
			skip: !userTimezoneData,
		});

	useEffect(() => {
		if (todaysTaskData) {
			setTotalTasksAssignedToday(
				todaysTaskData.user_reporting_view.reduce((acc, curr) => {
					return acc + curr.subordinate_details.allTasks.aggregate.count;
				}, 0)
			);
			setTotalTasksCompletedToday(
				todaysTaskData.user_reporting_view.reduce((acc, curr) => {
					return acc + curr.subordinate_details.completedTasks.aggregate.count;
				}, 0)
			);
		}
	}, [todaysTaskData]);

	useEffect(() => {
		if (weeklyTaskData) {
			let allTaskCount = weeklyTaskData.user_reporting_view.reduce(
				(acc, curr) => {
					let countObj =
						curr.subordinate_details.user_tasks_status_by_date_aggregate
							.aggregate.sum;
					let sumOfAll = Object.keys(countObj).reduce((sum, key) => {
						if (typeof countObj[key] === "number") {
							return sum + parseFloat(countObj[key] || 0);
						} else {
							return sum;
						}
					}, 0);
					return acc + sumOfAll;
				},
				0
			);
			let completedTaskCount = weeklyTaskData.user_reporting_view.reduce(
				(acc, curr) => {
					let countObj =
						curr.subordinate_details.user_tasks_status_by_date_aggregate
							.aggregate.sum;
					return acc + countObj.completed;
				},
				0
			);
			setTotalTasksAssignedLastWeek(allTaskCount);
			setTotalTasksCompletedLastWeek(completedTaskCount);
		}
	}, [weeklyTaskData]);

	const userTypeId = userData?.getUsersById?.user_access?.access_id;
	const userName =
		userData?.getUsersById?.first_name +
		" " +
		userData?.getUsersById?.first_name;

	useEffect(() => {
		if (lastScreenData && lastScreenData?.userData?.last_screen !== "/") {
			UPDATE_USER_LAST_SCREEN_MUTATION({
				variables: {
					user_id: localStorage.getItem("user_id"),
					last_screen: "/",
				},
			});
		}
	}, [lastScreenData]);

	const getHeadingText = () => {
		switch (userTypeId) {
			case "1":
				return "business";
			case "2":
				return "area";
			case "3":
				return "location";
			case "4":
				return "shift";

			default:
				break;
		}
	};

	if (
		locationLoading ||
		employeeLoading ||
		userTimezoneDataLoading ||
		todaysTaskDataLoading ||
		ownerlocationLoading
	) {
		return <Loader className="full_screen" />;
	}

	const onShowModal = () => {
		if (
			Math.ceil(
				(totalTasksCompletedLastWeek / totalTasksAssignedLastWeek) * 100
			) > 80
		) {
			setIsModalVisible(true);
		}
	};

	const onHideModal = () => {
		setIsModalVisible(false);
	};

	return (
		<Content className="site-body-layout dashboardPage">
			{userTypeId !== "1" && <Announcement />}
			<section className="summarySec">
				<div className="secSubTitle">
					<div className="stLeft">
						<h5>Summary for your {getHeadingText()}</h5>
					</div>
				</div>
				<div className="summaries">
					<ul className={`list-inline ${userTypeId && "sCol-3"}`}>
						{userTypeId === "2" && (
							<li>
								<SummaryCard
									icon="location"
									colorClass="card-color-1"
									count={locationData?.locations?.length || "0"}
									title="Total locations"
								/>
							</li>
						)}
						{userTypeId === "1" && (
							<li>
								<SummaryCard
									icon="location"
									colorClass="card-color-1"
									count={
										ownerlocationData?.getUsersById?.user_location_maps
											?.length || "0"
									}
									title="Total locations"
								/>
							</li>
						)}
						<li>
							<SummaryCard
								icon="employees"
								colorClass="card-color-2"
								count={employeeData?.employees?.length || "0"}
								title="Total employees"
							/>
						</li>
						<li>
							<SummaryCard
								icon="tasks"
								colorClass="card-color-3"
								count={totalTasksCompletedToday + "/" + totalTasksAssignedToday}
								title="Completed tasks"
								subText="Today"
							/>
						</li>
						<li>
							<SummaryCard
								onShowModal={onShowModal}
								onHideModal={onHideModal}
								isModalVisible={isModalVisible}
								bussiness_name={
									userData?.getUsersById?.user_location_maps.map(
										(b) => b?.businessDetails?.business_name
									)[0]
								}
								icon="medal"
								colorClass="card-color-4"
								count={
									!!totalTasksCompletedLastWeek && !!totalTasksAssignedLastWeek
										? !weeklyTaskDataLoading &&
										  Math.ceil(
												(totalTasksCompletedLastWeek /
													totalTasksAssignedLastWeek) *
													100
										  ) + "%"
										: "0%"
								}
								title="Seal of approval"
								subText="Last 7 Days"
							/>
						</li>
						{userTypeId !== "5" && (
							<li>
								<SummaryCard
									icon="tasks"
									colorClass="card-color-5"
									count={
										totalTasksCompletedLastWeek +
										"/" +
										totalTasksAssignedLastWeek
									}
									title="Tasks completed"
									subText="Last 7 Days"
								/>
							</li>
						)}
					</ul>
				</div>
			</section>
			<Row gutter={20}>
				<Col lg={12} xs={24} className="mt-3">
					<TaskForDay
						userTimeZone={userTimezoneData?.getUsersById.time_zone}
						userName={userName}
					/>
				</Col>
				<Col lg={12} xs={24} className="mt-3">
					<Escalations
						userTimeZone={userTimezoneData?.getUsersById.time_zone}
						userTypeId={userTypeId}
					/>
				</Col>
			</Row>
			<Row gutter={20}>
				<Col lg={10} xs={24} className="mt-4">
					<TopPerformer
						userTimeZone={userTimezoneData?.getUsersById.time_zone}
						userTypeId={userTypeId}
					/>
				</Col>
				<Col lg={14} xs={24} className="mt-4">
					<EmployeesLeave
						userTimeZone={userTimezoneData?.getUsersById.time_zone}
						userTypeId={userTypeId}
					/>
				</Col>
			</Row>
		</Content>
	);
};
